define('commentsTagView',[
  'module',
  'marionette',
  'underscore',
  'template!commentsTagView'
], function(
  Module,
  Marionette,
  _,
  Tpl
) {
  'use strict';

  Module.exports = Marionette.ItemView.extend({    
    className: 'comments-tag-view',
    template: Tpl,

    events: {
      'click': 'onClick'
    },

    modelEvents: {
      'change:selected': 'render'
    },
    
    serializeData: function () {     
      return {
        name: this.model.get('name'),
        showDeleteButton: this.options.showDeleteButton
      };
    },

    onRender: function() {
      this.$el.attr('data-selected', this.model.get('selected'));
    },

    onClick: function(e) {      
      e.stopPropagation();
      this.trigger('click', this.model);
    }
  });   
});
